/******************************************************************************
 * Copyright (C) 2024 The Trustees of Indiana University
 * SPDX-License-Identifier: BSD-3-Clause
 *****************************************************************************/

export function remToPixel(rem) {
	return parseInt(rem) * 16;
}
